// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssScoreStatusSchema = z.enum(['PENDING','SCORED','UNSCORED'] as const);

export type CvssScoreStatusType = `${z.infer<typeof CvssScoreStatusSchema>}`

export default CvssScoreStatusSchema;
